import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useStateInRef } from 'seagull';
import { useStore } from '~/contexts';
import { useContacts } from '~/hooks/reactQuery/queries/useContacts';
import { isClientDetailQuery } from '~/hooks/reactQuery/queries/useContactSummaryMutations.utils';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { PusherEvent, useBusinessChannelEventBinder } from '~/pusher';
import { selectors } from '~/store/state-selectors';
import { markContactEmailUpdateComplete } from './usePendingContactEmailUpdates';
function useInvalidateContactAddressQueries() {
    const queryClient = useQueryClient();
    return ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                QueryKeys.Contacts
            ]
        });
        queryClient.invalidateQueries({
            queryKey: [
                QueryKeys.ContactSummaries
            ]
        });
        queryClient.invalidateQueries({
            predicate: (param)=>{
                let { queryKey } = param;
                return isClientDetailQuery(queryKey);
            }
        });
    };
}
export function usePendingContactEmailUpdatesListener() {
    const isAuthenticated = useStore(selectors.user.hasUserInfo);
    const isReviewer = useStore(selectors.user.isReviewer);
    useContacts({
        enabled: isAuthenticated && !isReviewer
    });
    const invalidateContactAddressQueries = useInvalidateContactAddressQueries();
    const { startListening } = useBusinessChannelEventBinder(PusherEvent.ContactUpdated, 'mgmt');
    const getOnContactUpdated = useStateInRef((event)=>{
        if (isReviewer) return;
        markContactEmailUpdateComplete(event.payload.contactUpdated.userId);
        invalidateContactAddressQueries();
    });
    useEffect(()=>{
        startListening((event)=>getOnContactUpdated()(event));
    }, []);
}
